import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "justMessageMeals",
  "sendPhoto",
  "instantFeedback",
  "automaticReminders",
  "personalCoach",
  "trackWithoutApp",
] as const

export default function IdealTracking() {
  return <MultiSelectPage translationKey="idealTracking" options={OPTIONS} />
}
